import { forwardRef } from 'react';
import styled from 'styled-components';
import { X_AXIS_CONTAINER_CLASS_NAME } from '@ardoq/global-consts';
import { XAxisProps } from '../types';
import { XAxisLabelRow } from './xAxisLabelRow';
import { DomainRangeLabelRow } from './DomainRangeLabelRow';
import { ChartDimensions } from '@ardoq/graph';

const XAxisContainer = styled.div.attrs({
  className: `${X_AXIS_CONTAINER_CLASS_NAME} xAxis`,
})`
  flex: 0 1 auto;
`;

type TimeAxisArgs = {
  xAxisData: XAxisProps;
  dimensions: ChartDimensions;
};

export const XAxis = forwardRef<HTMLDivElement, TimeAxisArgs>(
  (
    {
      xAxisData: {
        topLabelRowProps,
        bottomLabelRowProps,
        xAxisContainerHeight,
        visibleDomainRowLabel,
      },
      dimensions,
    },
    ref
  ) => {
    if (!dimensions.chart.width) {
      return null;
    }
    return (
      <XAxisContainer
        ref={ref}
        style={{
          width: Math.max(
            0,
            dimensions.chart.width +
              dimensions.margin.left +
              dimensions.margin.right
          ),
          height: xAxisContainerHeight + 1,
        }}
      >
        {visibleDomainRowLabel ? (
          <DomainRangeLabelRow
            visibleDomainRowLabel={visibleDomainRowLabel}
            dimensions={dimensions}
          />
        ) : null}
        {topLabelRowProps ? <XAxisLabelRow {...topLabelRowProps} /> : null}

        <XAxisLabelRow {...bottomLabelRowProps} />
      </XAxisContainer>
    );
  }
);
